import { Injectable } from "@angular/core";
import { DwdmDiagramAbstractConverterAmplifiers } from "../../diagram/converter/dwdm-diagram-abstract-converter-amplifiers";
import { DwdmDiagramConverterHelper } from "../../diagram/converter/dwdm-diagram-converter-helper";
import { AmplifiersConverterData } from "../../diagram/converter/dwdm-diagram-converter.models";
import { AmplifierDirectionMap, AmplifierElement } from "../../diagram/models/diagram.models";
import { Amplifier } from "../steps/5-amplifiers/amplifiers-step.model";

/**
 * Implementação da @see DwdmDiagramAbstractConverterAmplifiers para a wizard de criação de circuitos DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramWizardConverterAmplifiersService extends DwdmDiagramAbstractConverterAmplifiers {

    public convert(amplifiersData: AmplifiersConverterData): AmplifierDirectionMap {
        return super.convertData(amplifiersData, this.buildAmplifier);
    }

    protected buildAmplifier(amplifier: Amplifier, amplifierData: any): AmplifierElement {
        const { direction, amplifierType, state, name } = amplifierData;

        return {
            id: DwdmDiagramConverterHelper.createId(),
            direction,
            type: amplifierType,
            name,
            state
        }
    }

}
